import request from '../../utils/request'

export default {
  getAll: data => request({
    url: '/api/services/app/reimbursement/GetAll',
    method: 'get',
    params: data
  }),
  get: data => request({
    url: '/api/services/app/reimbursement/Get',
    method: 'get',
    params: data
  }),
  getForEdit: data => request({
     url: '/api/services/app/reimbursement/GetForEdit',
     method: 'get',
     params: data
  }),
  create: data => request({
    url: '/api/services/app/reimbursement/Create',
    method: 'post',
    data: data
  }),
  update: data => request({
    url: '/api/services/app/reimbursement/Update',
    method: 'put',
    data: data
  }),
  delete: function(data) {
    return request({
      url: '/api/services/app/reimbursement/delete',
      method: 'delete',
      params: data
    })
  }
}
